var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 9.5002C1.33325 10.623 1.56604 11.7348 2.01834 12.7721C2.47063 13.8095 3.13356 14.752 3.96929 15.546C4.80502 16.3399 5.79717 16.9697 6.8891 17.3994C7.98103 17.829 9.15136 18.0502 10.3333 18.0502C11.5151 18.0502 12.6855 17.829 13.7774 17.3994C14.8693 16.9697 15.8615 16.3399 16.6972 15.546C17.5329 14.752 18.1959 13.8095 18.6482 12.7721C19.1005 11.7348 19.3333 10.623 19.3333 9.5002C19.3333 8.37739 19.1005 7.26559 18.6482 6.22825C18.1959 5.19092 17.5329 4.24837 16.6972 3.45443C15.8615 2.66049 14.8693 2.0307 13.7774 1.60103C12.6855 1.17135 11.5151 0.950195 10.3333 0.950195C9.15136 0.950195 7.98103 1.17135 6.8891 1.60103C5.79717 2.0307 4.80502 2.66049 3.96929 3.45443C3.13356 4.24837 2.47063 5.19092 2.01834 6.22825C1.56604 7.26559 1.33325 8.37739 1.33325 9.5002Z",
    stroke: "#ED7047",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 6.65039V10.4504",
    stroke: "#ED7047",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 13.2998V13.3093",
    stroke: "#ED7047",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.7c4db217b24e0e63380d0edd595a5b72.svg";
export { ForwardRef as ReactComponent };